import getLocalString from "constants/Localization";
import { useUpdateDailyFormInspectionQuestionMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateDailyFormInspectionQuestion() {
  const [mutation, { loading, data, error }] = useUpdateDailyFormInspectionQuestionMutation({
    refetchQueries: ["getDailyFormInspectionQuestions"],
  });

  const [updateDailyFormInspectionQuestion, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateDailyFormInspectionQuestion",
    },
    {
      successMessage: getLocalString("fleet.update-inspection-question-success"),
      failureMessage: getLocalString("fleet.update-inspection-question-failure"),
    }
  );

  return [updateDailyFormInspectionQuestion, context] as const;
}
